export const periods = [
    { id: '7', name: 'common.filters.periods.7' },
    { id: '14', name: 'common.filters.periods.14' },
    { id: '30', name: 'common.filters.periods.30' },
    { id: '90', name: 'common.filters.periods.90' },
    { id: '180', name: 'common.filters.periods.180' },
    { id: '360', name: 'common.filters.periods.360' },
    { id: '0', name: 'common.filters.periods.allTime' },
    { id: 'custom', name: 'common.filters.periods.customRange' },
];
